import { Authentication } from 'src/modules/sign-in/models/authentication.model';
import { SignUpData } from '../../models/forms/sign-up.model';
import { RecoverPasswordData } from '../../models/reset-password.model';

export class RecoverPassword {
  static readonly type = '[Password] Recover';

  constructor(
    public recoverPassword: RecoverPasswordData
  ) {}
}

export class ResetPassword {
  static readonly type = '[Password] Reset';

  constructor(
    public email: string
  ) {}
}

export class RefreshSession {
  static readonly type = '[User] Refresh Session';
}

export class Logout {
  static readonly type = '[User] Logout';
}

export class SignIn {
  static readonly type = '[User] Sign In';

  constructor(
    public authentication: Authentication
  ) {}
}

export class SignUp {
  static readonly type = '[User] Sign Up';

  constructor(
    public signUpData: SignUpData
  ) {}
}

export class SendActivationLink {
  static readonly type = '[User] Send Activation Link';

  constructor(
    public email: string
  ) {}
}
